import React, {useContext, useReducer} from 'react';

import { userReducer } from '../reducers/userReducer';
import {getSessionUser, getSnackBarMessage} from '../utils/sessionUtils';

export const initialState = {
    userId: -1,
    username: undefined,
    userType: undefined,
    firstName: undefined,
    lastName: undefined,
    cagId: undefined,
    fmapRole: undefined,
    personId: undefined,
    agentId: undefined,
    locked: undefined
}

const UserContext = React.createContext(initialState);

export const UserProvider = ({children}) => {
    const sessionUser = getSessionUser();
    const retrieveSnackBarMessage = getSnackBarMessage();
    const [user, dispatch] = useReducer(userReducer, sessionUser);
    const uContext = {user, dispatch};
    return <UserContext.Provider value={uContext}>{children}</UserContext.Provider>
}

export function useUserContext() {
    const cntxt = useContext(UserContext);
    return cntxt ? cntxt : undefined;
}
